import React, { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Pages/Header';
import Sidebar from '../Pages/Sidebar';
import ProcessLoader from '../Components/ProcessLoader';
import axios from 'axios';
import { PAY_URL } from '../../../BaseURL';
import toast from 'react-hot-toast';
import CopyRight from '../Pages/CopyRight';
import Loader from '../Pages/Loader';
import { Pagination, Search } from '../Table';
import moment from 'moment';
import DropDonwlLimit from '../Components/DropDonwlLimit';

const EsicList = () => {

    const navigate = useNavigate();
    const [entity, setEntity] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);
    const [loader, setLoader] = useState(false);
    const [month, setMonth] = useState("");

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
        if (disable || month) {
            getHoliday();
        }
    }, [navigate, disable, month]);

    const getHoliday = () => {
        const myurl = `${PAY_URL}/user/list-esic-report`;
        const bodyFormData = new URLSearchParams();
        bodyFormData.append('month', month)
        bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
        bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
        axios({
            method: "POST",
            url: myurl,
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then((response) => {
            // console?.log("@@", response?.data);
            if (response?.data?.success) {
                const data = response?.data?.data[0]?.items
                setEntity(data || []);
                setDisable(false);
            } else {
                toast.error("Something went wrong");
            }
        }).catch((error) => {
            console?.log("Errors", error);
        });
    };

    const commentsData = useMemo(() => {
        let computedComments = entity;
        if (search) {
            computedComments = computedComments.filter(
                (e) =>
                    e.employeeName?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    e.fatherName?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    e.esic_ip?.toLowerCase()?.includes(search?.toLowerCase())
            );
        }
        setTotalItems(computedComments?.length);
        return computedComments?.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, limit, entity, month]);

    const handleRefresh = () => {
        setSearch("");
        setCurrentPage(1);
        setlimit(10);
        setDisable(true);
        setLoader(false);
        getHoliday();
    }

    const handleDownload = () => {
        if (!month) {
            toast.error('Please select month')
            return
        }
        setLoader(true);
        const myurl = `${PAY_URL}/user/esic-report-download`;
        const bodyFormData = new URLSearchParams();
        bodyFormData.append('month', month)
        bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
        bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
        bodyFormData.append('print_date', true);
        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then((response) => {
            if (response.data.success === true) {
                const fileUrl = response.data.data.file;
                toast.success(response?.data?.message);
                window.open(fileUrl, '_blank');
                toast.success(response?.data.message);
            }
            setLoader(false);
        }).catch((error) => {
            console.log(error, '!!');
            toast.error(error?.response?.data.message);
            setLoader(false);
        });
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title user-title">ESIC Report Management</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/user/dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active">ESIC Report Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row filter-row justify-content-end">
                        <div className='col-md-4 col-lg-4 col-sm-12'>
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    <select className="form-select form-control" value={month} onChange={(e) => setMonth(e.target.value)}
                                        aria-label="Default select example">
                                        <option value=''>Select Month</option>
                                        <option value='1'>January</option>
                                        <option value='2'>February</option>
                                        <option value='3'>March</option>
                                        <option value='4'>April</option>
                                        <option value='5'>May</option>
                                        <option value='6'>June</option>
                                        <option value='7'>July</option>
                                        <option value='8'>August</option>
                                        <option value='9'>September</option>
                                        <option value='10'>October</option>
                                        <option value='11'>November</option>
                                        <option value='12'>December</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12 col-md-8">
                            <div className="row justify-content-end">
                                <div className="col-md-12 mb-2">
                                    <div className="justify-content-end d-flex align-center flex-wrap gap-2">
                                        <div className="seletePage d-flex gap-2 align-items-center ">
                                            <p className="mb-0">Rows per page:</p>
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <DropDonwlLimit limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='butotn' onClick={handleRefresh}>
                                                        <i className="fa-solid fa-arrows-rotate"></i>
                                                    </button>
                                                </div>
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='button' onClick={handleDownload}>
                                                        {loader ? <ProcessLoader /> : <i className="fa-solid fa-download"></i>}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tableSearch">
                                            <form action="">
                                                <Search
                                                    onSearch={(value) => {
                                                        setSearch(value);
                                                        setCurrentPage(1);
                                                    }} />
                                                <span className="search">
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                </span>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {disable === false ? (
                        <div className="card p-3 ">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-responsive">
                                        <table className="table table-striped custom-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Sr.</th>
                                                    <th>Name</th>
                                                    <th>Father Name</th>
                                                    <th>DOB</th>
                                                    <th>ESIC No.</th>
                                                    <th>Pr. Days</th>
                                                    <th>Monthly Wages</th>
                                                    <th>ESIC (0.75%)</th>
                                                    <th>ESIC (3.25%)</th>
                                                    <th>ESIC (4.00%)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {commentsData?.map((elem, i) =>
                                                    <tr key={elem?._id}>
                                                        <td>{(currentPage - 1) * limit + i + 1}</td>
                                                        <td>{elem?.employeeName}</td>
                                                        <td>{elem?.fatherName}</td>
                                                        <td>{elem?.dob ? moment(elem?.dob).format('YYYY-MM-DD') : "-"}</td>
                                                        <td>{elem?.esic_ip || "-"}</td>
                                                        <td>{elem?.work_day || "-"}</td>
                                                        <td>{(elem?.basic).toFixed(2) || "-"}</td>
                                                        <td>{(elem?.esicAmount1).toFixed(2)}</td>
                                                        <td>{(elem?.esicAmount2).toFixed(2)}</td>
                                                        <td>{(elem?.esicAmount3).toFixed(2)}</td>
                                                    </tr>
                                                )}

                                                {commentsData?.length === 0 ? (
                                                    <tr>
                                                        <td colspan="999">
                                                            <div className="no-table-data">
                                                                No Data Found!
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row align-center mt-3 user-account">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                            <div className="dataTables_paginate paging_simple_numbers"
                                                id="DataTables_Table_0_paginate">
                                                <Pagination
                                                    total={totalItems}
                                                    itemsPerPage={limit}
                                                    currentPage={currentPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : month !== "" ? <Loader /> : <h4 className='d-flex justify-content-center align-items-center' style={{ marginTop: "100px" }}>Please select month</h4>}

                    <CopyRight />
                </div>
            </div>
        </div>
    )
}

export default EsicList